import { useState } from "react";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Book = () => {
    const [booked, setBooked] = useState(false);

    return (
        <section id="book" data-testid="book-section" className="border-b border-line bg-bone">
            <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: EASE }}
                    className="grid grid-cols-1 gap-12 lg:grid-cols-2"
                >
                    <div>
                        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-mutedink">
                            Book a time
                        </p>
                        <h2 className="font-syne text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">
                            New patients are usually seen within{" "}
                            <span className="font-cormorant italic font-medium text-ochre">7 days.</span>
                        </h2>
                        <p className="mt-6 max-w-md text-sm leading-relaxed text-mutedink">
                            Demo booking only. Physio on Elm is a fictional clinic — this will not
                            book a real appointment.
                        </p>
                    </div>
                    {booked ? (
                        <p
                            data-testid="askbox-demo-booked"
                            className="border border-line bg-sand px-6 py-8 text-sm leading-relaxed text-mutedink"
                        >
                            Request noted locally. No appointment was booked — this is not a real
                            practice.
                        </p>
                    ) : (
                        <form
                            className="flex flex-col gap-4"
                            onSubmit={(e) => {
                                e.preventDefault();
                                setBooked(true);
                            }}
                        >
                            <input
                                required
                                placeholder="Name"
                                className="border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink"
                            />
                            <input
                                required
                                type="tel"
                                placeholder="Phone"
                                className="border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink"
                            />
                            <button
                                type="submit"
                                className="self-start bg-ink px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:bg-ochre"
                            >
                                Request a demo time
                            </button>
                        </form>
                    )}
                </motion.div>
            </div>
        </section>
    );
};
